import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import  {AuthContextProvider} from './context/AuthContext'
ReactDOM.render(

 
    <AuthContextProvider><Router><App /></Router></AuthContextProvider> 
      
    
    
  ,
  document.getElementById('root')
);
